// Import your custom colors
import colors from "assets/theme-dark/base/colors";

const { light, white } = colors;

const buttonBase = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    // Override styles for the root
    root: { 
      color: white.main,
      
      // Increase specificity for targeted classes
      '&.MuiPickersDay-root': {
        color: white.main,
      },
      '&.MuiPickersDay-today': {
        color: white.main,
        '&:not(.Mui-selected)': {
        border: `1px solid ${light.main}`, // Example border override
      },
      },
      '&.MuiPickersDay-dayWithMargin': {
        color: white.main,
      },

    },
  },
};

export default buttonBase;